<div class="documentation container">
  <aside class="documentation__sidebar">
    <ul>
      @for (doc of tableOfContent; track $index) {
      <li>
        <a [routerLink]="[doc.slug]" routerLinkActive="--is-active">{{ doc.title }}</a>
        <ul>
          @for (chapter of doc.chapters; track $index) {
          <li>
            <a [routerLink]="[chapter.slug]" routerLinkActive="--is-active">{{ chapter.title }}</a>

            <ul>
              @for (child of chapter.children; track $index) {
              <li>
                <a [routerLink]="[child.slug]" routerLinkActive="--is-active">{{ child.title }}</a>
              </li>
              }
            </ul>
          </li>
          }
        </ul>
      </li>
      }
    </ul>
  </aside>
  <div class="documentation__content">
    <markdown *ngIf="markdownContent" [data]="markdownContent"></markdown>
  </div>
</div>
